module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg11.dbbed0f1.jpg";